/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React from 'react';
// material
import Copy from 'material/copy/copy';
import Title from 'material/copy/title/title';
import Tip from 'material/message/tip/tip';
// styles
import injectSheet from 'react-jss';
import styles from 'pages/dashboard/reports/detail/area/area_styles';



/* ========== ~~~~~~~~~~ REPORT DETAIL : AREA ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
const ReportDetailArea = (props) => {
    return(
        <div className={`area ${props.name} ${props.classes.area} ${props.klass}`}>
			<Copy>
                <Title variant={`withtip`}>
                    <h2>{props.title}</h2>
                    {props.tooltip ? <Tip space={`left`} content={props.tooltip} /> : null}
                </Title>
            </Copy>
            <div className={`settings`}>
            	{props.children}
            </div>
        </div>
    );
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// will be utilized in parent component after being infused with app state & actions
export default injectSheet(styles)(ReportDetailArea);
